import type { State } from '../../types';
import type { SubstanceViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function substancesDeleted(state: State): SubstanceViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.substancesById).filter(function (e) {
    return e.deleted;
  });
}
